export { P20FrontPage as default } from './P20FrontPage';
